import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { AssetFiltersCountLabel } from "./asset-filters-count-label"

export function AssetOpenFiltersButton({ isOpen, handleClick }) {
    return (
        <Button
            onClick={handleClick}
            startIcon={<Iconify icon="mdi:filter" height="16px" width="16px" />}
            data-cy="open-close-filter-btn"
            endIcon={<AssetFiltersCountLabel isOpen={isOpen} />}
        >
            {`${isOpen ? "Close" : "Open"} Filters`}
        </Button>
    )
}
